import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { getImageFileURL, getPublicImageURL } from "../_helpers/image";
import log from "cslog"
import { useItemsFine, useSingleItem, useUpdateItemMutation } from "../_actions/app/items";


function LinkCreationModal({ trigger, data }) {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const { data: dataTemplate, isLoading: loadingTemplate, isSuccess: successTemplate } = useSingleItem("qdb_creation_template", `/${data?.id}`, open);

    const { data: dataCreations, isLoading: loadingCreations, isSuccess: successCreations } = useItemsFine(
        "qp_creation",
        `limit=-1&fields=id,title,preview,slug,data&filter=${JSON.stringify({
            "_and": [
                { "count(templates)": { _eq: 0 } },
                { type: { _eq: "singlepage" } },
                // { archived: { _eq: false } }
            ]
        })}`,
        !!data?.id,
        false
    )

    const mutationUpdate = useUpdateItemMutation(() => {
        log.p("Update success");
        setOpen(false);
    })

    const [results, setResults] = useState([])
    const [not_found, setNotFound] = useState(false);


    const findOrigin = async () => {
        setLoading(true);
        console.clear();
        log.d(dataTemplate, "tempalte data")

        // extract tempalte element ids
        const pages = dataTemplate?.data?.data?.pages;
        const frontPage = pages[0];
        log.d(frontPage, "front page");
        const keys = Object.keys(frontPage.html).filter(key => key !== "frontSide")
        log.d(keys, "keys");

        log.d(dataCreations, "creations")
        log.p(`Searching in ${dataCreations?.length} creations...`)

        const out = [];

        const search_key = keys[4];
        log.d(search_key, "search key")

        for (let i = 0; i < dataCreations?.length; i++) {
            log.d(i, "searching this")
            const creation = dataCreations[i];
            const creationData = creation.data;
            const creationDataString = JSON.stringify(creationData);
            if (creationDataString.includes(search_key)) {
                log.p("search_key found")

                let found = true
                keys.forEach(key => {
                    if (!creationDataString.includes(key)) {
                        found = false;
                    }
                })
                if (found) {
                    out.push(creation)
                }
            }
        }

        log.d(out, "out founds")
        setResults(out)

        if (out.length === 0) {
            setNotFound(true);
        }
        setLoading(false);
    }


    useEffect(() => {
        if (successTemplate && successCreations && !loading) {
            setResults([]);
            setNotFound(false);
            findOrigin();
        }
    }, [data?.id, successTemplate, successCreations])


    // useEffect(() => {
    //     if (results.length === 1) {
    //         mutationUpdate.mutate({
    //             collection: "qdb_creation_template",
    //             id: data?.id,
    //             data: {
    //                 creation: results[0].id
    //             }
    //         })
    //     }
    // }, [results])


    return (
        <>
            <div
                onClick={() => setOpen(true)}
            >{trigger}</div>
            <Modal
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                width="900px"
                footer={[
                    <Button key="back" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>,
                    <Button key="action" type="primary"
                        //  loading={loading} 
                        onClick={findOrigin}>
                        {loadingTemplate && "Loading..."}
                        {successTemplate && "Find Origin"}
                    </Button>,
                    ...(results.map(result => {
                        return <Button key={result.id} type="primary" onClick={() => {
                            mutationUpdate.mutate({
                                collection: "qdb_creation_template",
                                id: data?.id,
                                data: {
                                    creation: result.id
                                }
                            })
                        }}>
                            Link "{result.title}"
                        </Button>
                    }))
                ]}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    gap: "20px"
                }}>
                    <img alt="preview"
                        style={{
                            height: "300px",
                            objectFit: "contain"
                        }}
                        src={getImageFileURL(data.preview?.filename_disk)}
                    />
                    <div>
                        <b>Result</b>
                        {successTemplate && <p>Template data loaded.</p>}
                        {loadingCreations && <p>Loading creations...</p>}
                        {successCreations && <p>{dataCreations?.length} creation(s) found.</p>}
                        {not_found && <p style={{ color: "red" }}>No creation found.</p>}
                    </div>

                    <div>
                        {results.map(result => {
                            return <img alt="preview"
                                style={{
                                    height: "300px",
                                    objectFit: "contain",
                                    cursor: "pointer"
                                }}
                                src={getPublicImageURL(result.preview)}
                                onClick={() => {
                                    window.open(`https://show.qureal.com/s/${result.slug}`, "_blank")
                                }}
                            />
                        })}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default LinkCreationModal;